<template>
  <div id="sala-municipio-header">
    <v-row>
      <v-col>
        <h2>{{ city }}</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-bottom-navigation :value="activeBtn" color="primary">
          <v-divider vertical></v-divider>

          <v-btn
            :to="'/sala-principal/' + cityId + '/sala-indicadores-municipio'"
          >
            <span>Mapa de Indicadores</span>
          </v-btn>

          <v-divider vertical></v-divider>

          <v-btn :to="'/sala-principal/' + cityId + '/cargos-funcoes'">
            <span>Cargos e Serviços</span>
          </v-btn>

          <v-divider vertical></v-divider>

          <v-btn :to="'/sala-principal/' + cityId + '/sala-5w2h'">
            <span>5W2H</span>
          </v-btn>

          <v-divider vertical></v-divider>

          <v-btn :to="'/sala-principal/' + cityId + '/sala-custo'">
            <span>Custo</span>
          </v-btn>

          <v-divider vertical></v-divider>

          <v-btn :to="'/sala-principal/' + cityId + '/sala-tempo'">
            <span>Tempo</span>
          </v-btn>

          <v-divider vertical></v-divider>

          <v-btn :to="'/cidade/' + cityId + '/geral'">
            <span>Pagina Anterior</span>
          </v-btn>

          <v-divider vertical></v-divider>
        </v-bottom-navigation>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    payload: { type: Object },
  },
  data() {
    return {
      activeBtn: 0,
      estado: this.$store.state.uf,
    };
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "city",
      "cityId",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
    ]),
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
